<template>
	<span :title="model">
		<v-autocomplete
			:hint="hint"
			persistent-hint
			multiple
			v-model="model"
			@input="updateMulti()"
			:search-input.sync="search"
			:disabled="disabled"
			:items="selectItems"
			:rules="computedRules"
			:label="label"
			:item-value="itemValue"
			:item-text="itemText"
			clearable
		>
			<template slot="selection" slot-scope="data">
				{{
					(!data.item
						? ''
						: !itemText
						? data.item
						: typeof itemText === 'function'
						? itemText(data.item)
						: data.item[itemText]) + (data.index !== model.length - 1 ? ',' : '')
				}}
			</template>
			<template slot="item" slot-scope="data">
				<span :class="{ 'is-separator': isSeparator(data.item) }">
					{{
						!data.item
							? ''
							: !itemText
							? data.item
							: typeof itemText === 'function'
							? itemText(data.item)
							: data.item[itemText]
					}}
				</span>
			</template>
		</v-autocomplete>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: ['values', 'itemText', 'itemValue'],
	data() {
		return {
			search: null,
		}
	},
	methods: {
		// FIXME : a real methods to do this must exists...
		isSeparator(data) {
			return (
				data === 'curveStyle' ||
				data === 'highPosition' ||
				data === 'embeddedTechnology' ||
				data === 'largeCarBoot' ||
				data === 'bio' ||
				data === 'sportif' ||
				data === 'socialRank' ||
				data === 'price5'
			)
		},
		updateMulti() {
			this.search = ''
			this.update()
		},
	},
	computed: {
		selectItems() {
			return typeof this.values === 'function' ? this.values() : this.values
		},
	},
}
</script>

<style lang="scss">
@import '../../assets/global.scss';

.is-separator {
	height: 100%;
	display: flex;
	align-items: center;
	border-bottom: $primary-color 1px solid !important;
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/multiSelectInput.vue